import Swiper from 'swiper/bundle';
const swiper = new Swiper('.swiper', {
  slidesPerView: 2,
  spaceBetween: 10,
  breakpoints: {
    // when winddow width is <= 759px
    575: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    767: {
      slidesPerView: 4,
      spaceBetween: 15,
    },
  },
  loop: false,
  centeredSlide: true,
  fadeEffect: true,
  grabCursor: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
